/** Characters in a ULID in canonical Crockford base-32 form. */
export const ULID_LENGTH = 26;

/**
 * Upper bound on the rendered width of one ULID character at Cloudscape's default
 * body font size (14px). ULIDs are uppercase base-32 minus I/L/O/U, so the glyphs
 * are digits and wide capitals; 9px is generous for the widest of them.
 */
const ID_GLYPH_WIDTH_PX = 9;

/** Horizontal padding Cloudscape puts inside a table cell (20px each side). */
const CELL_HORIZONTAL_PADDING_PX = 40;

/** Column width that fits an identifier of `characters` characters on one line. */
export const idColumnWidthPx = (characters: number): number =>
  characters * ID_GLYPH_WIDTH_PX + CELL_HORIZONTAL_PADDING_PX;

/** Width for a table column whose cells hold a ULID. 274px. */
export const ULID_COLUMN_WIDTH_PX = idColumnWidthPx(ULID_LENGTH);
